<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 17 16">
    <path
      d="M0.819336 1.11667C0.819336 0.629932 1.21392 0.235352 1.70066 0.235352H15.8018C16.2885 0.235352 16.6831 0.629932 16.6831 1.11667V1.11667C16.6831 1.60341 16.2885 1.99799 15.8018 1.99799H1.70066C1.21392 1.99799 0.819336 1.60341 0.819336 1.11667V1.11667ZM0.819336 14.3365C0.819336 13.8497 1.21392 13.4551 1.70066 13.4551H15.8018C16.2885 13.4551 16.6831 13.8497 16.6831 14.3365V14.3365C16.6831 14.8232 16.2885 15.2178 15.8018 15.2178H1.70066C1.21392 15.2178 0.819336 14.8232 0.819336 14.3365V14.3365ZM7.86989 9.92987C7.86989 9.44313 8.26447 9.04855 8.75121 9.04855H15.8018C16.2885 9.04855 16.6831 9.44313 16.6831 9.92987V9.92987C16.6831 10.4166 16.2885 10.8112 15.8018 10.8112H8.75121C8.26447 10.8112 7.86989 10.4166 7.86989 9.92987V9.92987ZM7.86989 5.52327C7.86989 5.03653 8.26447 4.64195 8.75121 4.64195H15.8018C16.2885 4.64195 16.6831 5.03653 16.6831 5.52327V5.52327C16.6831 6.01001 16.2885 6.40459 15.8018 6.40459H8.75121C8.26447 6.40459 7.86989 6.01001 7.86989 5.52327V5.52327ZM3.92229 7.35704C4.14587 7.55266 4.14587 7.90047 3.92229 8.0961L1.6337 10.0986C1.31621 10.3764 0.819336 10.151 0.819336 9.72909V5.72404C0.819336 5.30218 1.31621 5.07671 1.6337 5.35451L3.92229 7.35704Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
